const fileMixin = {
  methods: {
    createBlob(arraybuffer, type) {
      return new Blob([arraybuffer], {
        type: type
      })
    },
    downloadFromUrl(url, filename) {
      const temporaryLinkElement = document.createElement('a')
      temporaryLinkElement.href = url
      temporaryLinkElement.download = filename
      document.body.appendChild(temporaryLinkElement)
      temporaryLinkElement.click()
      window.URL.revokeObjectURL(url)
      temporaryLinkElement.remove()
    },
    downloadBlob(blob, filename) {
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        const url = window.URL.createObjectURL(blob)
        this.downloadFromUrl(url, filename)
      }
    }
  }
}

export default fileMixin
